import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminPartnerService } from '../services/admin-partner.service';

export function useAdminFraud(params?: {
  page?: number;
  limit?: number;
  status?: string;
  level?: string;
}) {
  return useQuery({
    queryKey: ['admin', 'fraud', 'list', params],
    queryFn: () => adminPartnerService.getFraudAlerts(params),
  });
}

export function useAdminFraudAlert(id: string) {
  return useQuery({
    queryKey: ['admin', 'fraud', id],
    queryFn: () => adminPartnerService.getFraudAlertById(id),
    enabled: !!id,
  });
}

export function useAdminFraudStats() {
  return useQuery({
    queryKey: ['admin', 'fraud', 'stats'],
    queryFn: () => adminPartnerService.getFraudStats(),
  });
}

export function useReviewFraudAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      status,
      notes,
    }: {
      id: string;
      status: 'REVIEWED' | 'DISMISSED';
      notes?: string;
    }) => adminPartnerService.reviewFraudAlert(id, { status, notes }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'fraud'] });
    },
  });
}
